import { useState, useEffect } from 'react';

/**
 * useIsMobile — single source of truth for "are we on a phone?" across
 * the admin app. Locks the breakpoint at < 768 (tailwind `md`).
 *
 * Use this rather than ad-hoc window.innerWidth checks so we can flip
 * the breakpoint in one place if needed (e.g. to bump iPad Mini into
 * desktop mode at 768).
 */
export function useIsMobile(breakpoint = 768) {
  const get = () => (typeof window !== 'undefined' ? window.innerWidth < breakpoint : false);
  const [isMobile, setIsMobile] = useState(get);

  useEffect(() => {
    const onResize = () => setIsMobile(get());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
